import { render, staticRenderFns } from "./BHDZPage.vue?vue&type=template&id=89c4a458&scoped=true"
import script from "./BHDZPage.vue?vue&type=script&lang=js"
export * from "./BHDZPage.vue?vue&type=script&lang=js"
import style0 from "./BHDZPage.vue?vue&type=style&index=0&id=89c4a458&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c4a458",
  null
  
)

export default component.exports